







































import { Component, Vue } from 'vue-property-decorator';
import router from '../router';
import { MedTransGoConstants } from '../util/constants';
import { validationMixin } from 'vuelidate';
import { required, minLength } from 'vuelidate/lib/validators';
import { CreditCard } from '../types/request';
interface StripeWindow extends Window {
  Stripe: any;
}

@Component({
 mixins: [validationMixin],
 props: {
    billingLocations: {
        type: Array,
        required: false,
    },
 },
 data() {
    return {
        cardHolderName: '',
        isCardValid: true,
        selectedLocations: [],
        billingLocationOptions: [] as any,
    };
 },
 validations: {
    cardHolderName: {
      required,
      regex: (cardHolderName) => /^[a-zA-Z0-9 ]+$/.test(cardHolderName),
    },
 },
})
export default class CreditCardForm extends Vue {

    private creditCard: CreditCard = {};
    public mounted() {
        if (this.$props.billingLocations && this.$props.billingLocations.length) {
            this.$data.billingLocationOptions = this.$props.billingLocations.map((loc: any) => ({
            ...loc,
            locationName: loc.locationName || loc.name || '',
            }));
        }
        const stripe = (window as StripeWindow).Stripe(this.$store.state.stripePublicKey);
        const elements = stripe.elements();
        const style = {
            base: {
                'color': '#32325d',
                'fontFamily': '"verdana"',
                'fontSmoothing': 'antialiased',
                'fontSize': '16px',
                '::placeholder': {
                    color: '#aab7c4',
                },
            },
            invalid: {
                color: '#fa755a',
                iconColor: '#fa755a',
            },
        };
        // Create an instance of the card Element.
        const card = elements.create('card', {style});
        // Add an instance of the card Element into the `card-element` <div>.
        card.mount('#card-element');
        card.on('change', async (event: any) => {
            this.creditCard.cardToken = undefined;
            if (event.complete) {
                this.$data.isCardValid = true;
                const token = await stripe.createToken(card, {
                    name: this.$data.cardHolderName,
                });
                this.creditCard.cardToken = token;
            } else if (event.error) {
                this.$data.isCardValid = false;
            }
            this.creditCard.cardHolderName = this.$data.cardHolderName;
            this.creditCard.selectedLocations = this.$data.selectedLocations.map(
                (loc: any) => loc.id,
            );
            this.$emit(MedTransGoConstants.EVENT_CHANGE, this.creditCard);
        });
    }

    private setCardHolderName() {
        if (!this.$v.cardHolderName.$invalid) {
            this.creditCard.cardHolderName = this.$data.cardHolderName;
        } else {
            this.creditCard.cardHolderName = '';
        }
        this.creditCard.selectedLocations = this.$data.selectedLocations.map(
            (loc: any) => loc.id,
        );
        this.$emit(MedTransGoConstants.EVENT_CHANGE, this.creditCard);
    }

    private updateSelectedLocations() {
        this.creditCard.selectedLocations = this.$data.selectedLocations.map((loc: any) => loc.id);
        this.$emit(MedTransGoConstants.EVENT_CHANGE, this.creditCard);
    }
}
